import { isAxiosError } from "axios";
import axiosInstance from "../../utils/axiosInstance";
import {
  createRequestPrice,
  updateRequestPrice,
  setServiceRequest,
  setServiceRequests,
  setLoadingTrue,
  setLoadingFalse,
  setPriceLoadingTrue,
  setPriceLoadingFalse,
} from "../../store/slices/request";
import { setMessage } from "../../store/slices/message";
import { AppDispatch } from "../../store/store";
import {
  ICreateRequestPrice,
  IRequestQueryParams,
  IPrice,
  IUpdateRequestPrice,
  IServiceRequestResponseData,
} from "../../store/@types/requests";
import { IServiceRequestData } from "../../store/@types/requests";
import { getErrorMessage } from "./apiError";
import { IApiResponse } from "../../store/@types/api-response";

const requestEndpoint = "/api/v1/client/service-requests";
const requestPriceEndpoint = "/api/v1/client/service-request-prices";

export const create_request_service = async (
  dispatch: AppDispatch,
  formData: IServiceRequestData,
) => {
  dispatch(setLoadingTrue());
  try {
    const response = await axiosInstance.post(`${requestEndpoint}`, formData);

    const { message } = response.data;
    dispatch(setMessage({ type: "success", message: message }));
    return true;
  } catch (err) {
    const message = getErrorMessage(err, "Unable to submit service request.");
    dispatch(setMessage({ type: "error", message }));
    if (!isAxiosError(err)) console.error(err);
    return false;
  } finally {
    dispatch(setLoadingFalse());
  }
};

export const get_service_requests = async (
  dispatch: AppDispatch,
  params: IRequestQueryParams,
) => {
  dispatch(setLoadingTrue());

  try {
    const response = await axiosInstance.get<
      IApiResponse<IServiceRequestResponseData>
    >(`${requestEndpoint}`, {
      params,
    });

    dispatch(setServiceRequests(response.data));
  } catch (error) {
    if (isAxiosError(error)) {
      console.error(error.response?.data || error.message);
    } else {
      console.error(error);
    }
  } finally {
    dispatch(setLoadingFalse());
  }
};

export const get_service_request = async (
  dispatch: AppDispatch,
  id: string,
) => {
  dispatch(setLoadingTrue());
  try {
    const response = await axiosInstance.get(`${requestEndpoint}/${id}`);

    const { data } = response.data;
    dispatch(setServiceRequest(data));
  } catch (error) {
    if (isAxiosError(error)) {
      console.error(error.response?.data || error.message);
    } else {
      console.error(error);
    }
  } finally {
    dispatch(setLoadingFalse());
  }
};

// service request price
export const create_service_request_price = async (
  dispatch: AppDispatch,
  formData: ICreateRequestPrice,
) => {
  dispatch(setPriceLoadingTrue());
  try {
    const response = await axiosInstance.post(
      `${requestPriceEndpoint}`,
      formData,
    );
    const { message, data } = response.data;

    if (data) {
      dispatch(createRequestPrice(data as IPrice));
    }
    dispatch(setMessage({ type: "success", message }));
    return true;
  } catch (error) {
    if (isAxiosError(error)) {
      const message = error.response?.data?.message || error.message;
      dispatch(setMessage({ type: "error", message }));
    } else {
      dispatch(setMessage({ type: "error", message: "Unable to add price." }));
      console.error(error);
    }
    return false;
  } finally {
    dispatch(setPriceLoadingFalse());
  }
};

export const update_service_request_price = async (
  dispatch: AppDispatch,
  formData: IUpdateRequestPrice,
) => {
  dispatch(setPriceLoadingTrue());
  try {
    const response = await axiosInstance.patch(
      `${requestPriceEndpoint}`,
      formData,
    );
    const { message, data } = response.data;

    if (data) {
      dispatch(updateRequestPrice(data as IPrice));
    }
    dispatch(setMessage({ type: "success", message }));
    return true;
  } catch (error) {
    if (isAxiosError(error)) {
      const message = error.response?.data?.message || error.message;
      dispatch(setMessage({ type: "error", message }));
    } else {
      dispatch(
        setMessage({ type: "error", message: "Unable to update price." }),
      );
      console.error(error);
    }
    return false;
  } finally {
    dispatch(setPriceLoadingFalse());
  }
};
